var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"allReport",staticClass:"all-report"},[_vm._l((_vm.list),function(item){return _c('ReportCard',{key:item.seq + 'all',attrs:{"item":item,"isDeep":_vm.isDeep,"config":{
      isOrg: false,
      follow: true,
      plusName: '',
    },"chart":_vm.isShowChart,"readNum":item.readNum,"stat":_vm.stat},on:{"followClick":_vm.followOrg}})}),_c('CommonLoading',{attrs:{"type":'list',"status":_vm.ajaxStatus},on:{"reload":_vm.getData}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }